<template>
  <section class="details">
    <ContainerMedium>
      <div class="row align-items-center">

        <div class="col-lg-9 col-md-12">
          <div class="details__course">
            <picture class="details__author-avatar embed-responsive embed-responsive-16by9">
              <img
                class="embed-responsive-item"
                :src="thumb"
              />
            </picture>

            <div class="details__course__text-content">
              <router-link
                :to="{ name: 'category.show', params: {...course.course_category}}"
                class="details__course__category"
              >
                {{ course.course_category.name }}
              </router-link>

              <h2 class="details__course__title">{{ course.name }}</h2>
              
              <div class="details__course__text" >
                <h4 class="details__course__class">
                  <strong>{{ courseModuleClass.name }}</strong>
                </h4>

                <h3 class="details__course__module">
                  {{ courseModule.name }}
                </h3>
              </div>

              <CourseLoadDuration :duration="duration" />

              <ul class="details__course__tags" style="display: none">
                <li v-for="tag in course.tags" :key="tag.id">
                  <Tag :tag="tag" />
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          v-if="isLogged"
          class="col-auto text-right ml-lg-auto mt-4 mt-lg-0"
        >
          <CourseTogglePlaylistButton
            :course-id="course.id"
          />
        </div>
      </div>      
    </ContainerMedium>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'
  import CourseTogglePlaylistButton from '@/components/playlist/CourseTogglePlaylistButton'
  import Tag from '@/components/layout/Tag'
  import FlashSVG from '@/components/svg/FlashSVG'
  import CourseLoadDuration from '@/components/course/CourseLoadDuration'

  export default {
    components: {
      Tag,
      ContainerMedium,
      CourseTogglePlaylistButton,
      FlashSVG,
      CourseLoadDuration,
    },

    computed: {
      ...mapGetters('course', [
        'course',
        'courseModuleClass',
        'courseModule',
        'hasCourseAccess',
        'courseClasses',
        'courseModules'
      ]),

      ...mapGetters('user', [
        'isLogged'
      ]),

      duration () {
        return this.courseModuleClass.load_duration || this.course.load_duration 
      },

      thumb () {
        return this.hasCourseAccess ? this.courseModuleClass.thumb : this.course.thumb
      },
    },
  }
</script>

<style scoped lang="scss">
  .details {
    padding: 1.8rem;
    background: darken(#fff, 5%);
    border-bottom: 2px solid darken(#fff, 8%);


    &__author-avatar {
      flex: 0 0 1;
      width: 160px;
      border-radius: 5px;
    }

    &__course {
      display: flex;
      align-items: center;

      &__text-content {
        flex: 100%;
        padding-left: 10px;
      }

      &__category {
        display: block;
        font-size: 13px;
        color: lighten(#000, 40%);
        text-transform: uppercase;
        margin-bottom: 3px;
      }

      &__tags {
        margin-top: 10px;
        display: flex;

        & > li:not(:last-child) {
          margin-right: 5px;
        }
      }

      &__text {
        display: flex;
        align-items: center;

        &:before {
          order: 2;
          display: block;
          flex: 0 0 5px;
          height: 5px;
          background-color: #000;
          border-radius: 100%;
          content: '';
          margin: 0 8px;
        }
      }

      &__title {
        order: 1;
        font-family: 'Poppins';
        font-size: 1.2rem;
        font-weight: 600;
        margin-bottom: 5px;
      }

      &__class,
      &__module {
        order: 2;
        font-size: 12px;
        text-transform: uppercase;

        svg { width: 18px }
      }

      &__module { order: 3 }
      &__class { order: 1 }
    }

    @media (max-width: 550px) {
      padding: 20px 10px;

      .details__author-avatar {
        display: none;
      }

      &__course {
        &__text {
          flex-direction: column;
          align-items: flex-start;

          &:before { display: none }
        }

        &__class {
          margin-bottom: 5px;
        }
      }
    }
  }
</style>
